import { useRef, useEffect } from 'react';
import { Button, message, Modal } from "antd";
import { useAuth } from '../contexts/auth-context';

// breakpoint value = xs|sm|md|lg|xl
export const useLegalDocDialog = () => {
  const auth = useAuth();
  const legalDocRef = useRef(null);

  const showLegalDocumentDialog = (userData) => {
    let contentMessage = <p>Welcome to Punkypay! 
      To get started, we recommend reviewing our <a href="support" target="_blank" rel="noopener noreferrer">Support</a> page. 
      Please also review and agree to the <a href="terms-of-Use" target="_blank" rel="noopener noreferrer">Terms of Use</a>, <a href="privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>, and <a href="rmpa" target="_blank" rel="noopener noreferrer">Referral Marketing Program Agreement</a>. 
      </p>;
    if (userData?.legalDocument) {
      contentMessage = <p>We've updated our <a href="terms-of-Use" target="_blank" rel="noopener noreferrer">Terms of Use</a>, <a href="privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>, and <a href="rmpa" target="_blank" rel="noopener noreferrer">Referral Marketing Program Agreement</a>. 
      Please review and agree to the updated terms to continue.</p>
    }
    
    if(legalDocRef.current) return;

    legalDocRef.current = Modal.warning({
        title: 'Please Sign Legal Documents',
        content: contentMessage,
        maskClosable: false,
        closable: false,
        visible: false, // Start hidden
        footer: <div style={{display: 'flex', justifyContent: 'flex-end', gap: 8}}>
            <Button key="leave" color="primary" variant="outlined" onClick={() => {
                auth.signOut();
                legalDocRef.current?.destroy();
                legalDocRef.current = null;
              }}>
              Leave 
            </Button>
            <Button key="accept" type="primary" onClick={async () => {
              try {
                const result = await auth.saveLegalDocSigned();
                if (result.legalDocSigned) {
                  message.success('Success!')
                  legalDocRef.current?.destroy();
                  legalDocRef.current = null;
                } else {
                  message.error('Something went wrong! Refresh the browser and try again.')
                }
              } catch (error) {
                message.error('Something went wrong! Refresh the browser and try again.');
              }
            }}>
                I accept 
            </Button>
        </div>
    });
  }


  useEffect(() => {
    // show legal document dialog if value === false. Don't use !auth.legalDocSigned because value can be null which is a pending state
    if(auth.legalDocSigned === false) {
      showLegalDocumentDialog(auth.currentUser);
    }

    return () => {
        legalDocRef.current?.destroy();
        legalDocRef.current = null;
    }
  }, [auth.legalDocSigned])
}